<div class="row ss-top-menu">
    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6">
        <span class="ss-text-dashboard" style="vertical-align: -webkit-baseline-middle;">Designer Dashboard</span>
  </div>
  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6">
  </div>
</div>

<div class="container">
<div class="row task-cards">
    <a class="nav-link ss-nav-link card addCursor" id="handover-for-production">
      <div class="card-header border-bottom-0  text-center">
        10 -50% Designer Dashboard
      </div> 
    </a> 
    
  </div>

  <div class="row">
    <div class="col-md-8">
      <div class="row filter_style mt-4">
        <div class="col-md-2" style="margin-top: 30px;">
        <button [ngClass]="{'active': delayed_data == 'curr'}" class="btn btn-sm col_buttons mr-3 active" name="button" (click)="select_prev('curr')" type="button">Current Month</button>
        </div>
        <div class="col-md-2" style="margin-top: 30px;">
        <button class="btn btn-sm col_buttons mr-3" name="button" [ngClass]="{'active': delayed_data == 'prev'}" (click)="select_prev('prev')" type="button">Previous Month</button>
        </div>
    <div class="col-md-3 mb-3 mt-2">
            <span style="color: #8d0528;">From:</span>
            <input class="form-control from_date ss-date" id="from_date" name="from_date" type="date" (change)="changeDateFrom($event.target.value)">
          </div>
          <div class="col-md-3 mb-3 mt-2">
            <span style="color: #8d0528;">To:</span>
            <input class="form-control from_date ss-date" id="to_date" name="to_date" type="date" (change)="changeDateTo($event.target.value)">
          </div>
          <div class="col-md-1 text-center cursor-pointer destopSubmitDiv"
            style="margin-top: -6px;" (click)="filterDashboard()">
            <img src="./assets/img/dashboard/submit.png" style="margin-top: 20px;" class="pt-3 destopSubmit">
            <button class="button mobSubmit d-none" style="margin-top: 10px;">Submit</button>
          </div>
          </div>
          </div>
  </div>

  <div class="row filter_style mt-4" *ngIf="role=='community_manager'|| role =='business_head'|| role =='city_gm'">
    <div class="col-md-4 filter2 pb-3 pt-2" [ngClass]="{'d-none':role=='community_manager'|| role =='designer'|| role =='city_gm' || role=='design_manager'}">
        <!-- <span class="text-danger pull-right text-bold cursor-pointer mt-1" style="font-size: 12px">Clear</span> -->
          <span class="fltype">Filter by GM</span>
        <div class="floptions">
            <ng-select placeholder="Select GM" (change)="onItemSelect($event)">
                          <ng-option *ngFor="let item of general_manager" value="{{item.id}}">{{item.item_name}}</ng-option>
                        </ng-select>          
          </div>
      </div>
    <div class="col-md-4 filter2 pt-2 pb-3" [ngClass]="{'d-none':role=='community_manager'|| role =='designer'}" [ngStyle]="{'margin-left':(role =='city_gm' || role=='design_manager') ? '2%':'0%'}">
        <!-- <span class="text-danger pull-right text-bold cursor-pointer mt-1" (click)="ClearCmFilter()" style="font-size: 12px">Clear</span> -->
          <span class="fltype">Filter by CM</span>
        <div class="floptions">
            <ng-select placeholder="Select CM" (change)="onItemSelect2($event)">
                          <ng-option *ngFor="let item of community_manager" value="{{item.id}}">{{item.item_name}}</ng-option>
                        </ng-select>
          </div>
  
      </div>
      <div class="col-md-4 filter2 pt-2 pb-3" [ngClass]="{'d-none': role =='designer'}">
        <!-- <span class="text-danger pull-right text-bold cursor-pointer mt-1" (click)="CleardesignerFilter()" style="font-size: 12px">Clear</span> -->
          <span class="fltype">Filter by DESIGNER</span>
          <div class="floptions">
           <ng-select placeholder="Select Designer" (change)="onItemSelect3($event)">
                          <ng-option *ngFor="let item of designer" value="{{item.id}}">{{item.item_name}}</ng-option>
                        </ng-select>
          </div>
   </div>
  </div>
  <div class="row justify-content-center">
    <div class="col-md-12">
<div class="row mt-4">
  <div class="col-md-4">
    <div class="filter-2">
    <div class="heading pt-2 pl-1">Overall Performance</div>
    <div class="line_heading ml-1" style="width: 13rem !important;"></div>
    <div class="row mt-3 mb-3" *ngIf="doughnutChartData">
      <canvas baseChart
          [data]="doughnutChartData"
          [labels]="pieChartLabels"
          [chartType]="doughnutChartType"
          [colors]="colors"
          (chartHover)="chartHovered($event)"
          (chartClick)="chartClicked($event)"></canvas>
      </div>
      <div class="line_heading_2"></div>
      <div class="row mt-3 mb-3">
        <div class="col-md-12">
      <!-- <div style="display: block" class="mt-5"> -->
        <div *ngIf="barChartData">
      <canvas baseChart
        [datasets]="barChartData"
        [colors]="lineChartColors"
        [options]="barChartOptions"
        [legend]="barChartLegend"
        [chartType]="barChartType"
        id="barChartCS"
        (chartClick)="chartClickeing($event)"> 
      </canvas>
      </div>
      <div *ngIf="show_value" class="ml-4">
        <div *ngIf="show_book"><span style="color: #8d0528;">Order Booking Value:</span> {{display_val1 | number : '.1-2'}}</div>
        <div *ngIf="show_confirm"><span style="color: #8d0528;">Order Confirmation Value:</span> {{display_val2 | number : '.1-2'}}</div>
        </div>
      </div>
    <!-- </div> -->
      </div>
      <div class="line_heading_2"></div>
      <div class="heading_2 mt-2" style="text-align: center;">Order Confirmation Value</div>
      <div class="row pb-4 mt-4">
      <div class="col-md-11">
        <div *ngIf="barChartData2">
      <canvas baseChart
        [datasets]="barChartData2"
        [labels]="barChartLabels2"
        [colors]="lineChartColors2"
        [options]="barChartOptions2"
        [legend]="barChartLegend2"
        [chartType]="barChartType2"
        id="barChartCS"
        (chartHover)="chartHovered($event)"
        (chartClick)="chartClicked9($event)"> 
      </canvas>
      </div>
    </div>
      </div>
    </div>
    </div>
    <div class="col-md-8 ">
      <div class="row filter-2" style="height: 26.4rem;">
        <div class="col-md-12 mb-3">
      <div class="heading mt-2">Site Measurement To Mat. Selection</div>
    <div class="line_heading" style="width: 21rem !important;"></div>
    <table class="table_style mt-4 ml-5" *ngIf="site_measure_data && site_measure_data.length > 0">
      <tr style="border-bottom: 0.5px solid #000000;">
        <th scope="col" class="border_right" rowspan="2" style="border-bottom: 0.5px solid #000000; text-align: center;">Lead Name - Id</th>
        <th scope="col" colspan="2" class="border_right">Site Measurement</th>
        <!-- <th scope="col" colspan="2" class="border_right">Design Closure</th> -->
        <th scope="col" colspan="2" class="border_right">Material Selection</th>
        <th scope="col" class="border_right" rowspan="2" style="border-bottom: 0.5px solid #000000;">All Done</th>
        </tr>
        <tr>
          <td class="border_right" style="border-bottom: 0.5px solid #000000;">Target</td>
          <td class="border_right" style="border-bottom: 0.5px solid #000000;">Actual</td>
          <!-- <td class="border_right" style="border-bottom: 0.5px solid #000000;">Target</td>
          <td class="border_right" style="border-bottom: 0.5px solid #000000;">Actual</td> -->
          <td class="border_right" style="border-bottom: 0.5px solid #000000;">Target</td>
          <td class="border_right" style="border-bottom: 0.5px solid #000000;">Actual</td>
          </tr>
          <ng-container *ngFor="let item of site_measure_data | paginate
          : {
              id:'pagination1',
              itemsPerPage: per_page,
              currentPage: current_page,
              totalItems: total_page
            }; let i=index">
          <tr style="border-bottom: 0.5px solid #000000;">
            <td class="data_align">{{item.lead_name}}-{{item.lead_id}}</td>
            <td class="data_align" [style.color]="item.site_measurement.color">{{item.site_measurement.target | date:'dd/MM/yyyy'}}</td>
            <td class="data_align">{{item.site_measurement.actual | date:'dd/MM/yyyy'}}</td>
            <!-- <td class="data_align">6868</td>
            <td class="data_align">6868</td> -->
            <td class="data_align">{{item.material_selection.target | date:'dd/MM/yyyy'}}</td>
            <td class="data_align">{{item.material_selection.actual | date:'dd/MM/yyyy'}}</td>
            <td class="data_align" *ngIf="item.overall_color === 'green'"><img
                    src="./assets/img/finance/path.png"
                  /></td>
          <td class="data_align" *ngIf="item.overall_color === 'red'"><img
                    src="./assets/img/finance/close.png"
                  /></td>        
            </tr>
            </ng-container>
            <!-- <div class="text-center">
          <pagination-controls autoHide="true" (pageChange)="current_page = getSiteMeasurementData($event,current_user_id)"></pagination-controls>
         </div> -->
            
      </table>
      <div class="col-md-12" *ngIf="site_measure_data && site_measure_data.length == 0">
            <div class="boq-img text-center" >
              <img src="../../../assets/img/desktop.png" style="height: 250px;width: 300px">
            </div>
            <p class=" pb-4" style="font-size: 21px;text-align: center;color: dimgray">Nothing to show...</p>
            
          </div>
      <div class="text-center mt-3" *ngIf="site_measure_data && site_measure_data.length > 0">
          <pagination-controls id="pagination1" autoHide="true" (pageChange)="current_page = getSiteMeasurementData($event)"></pagination-controls>
         </div>
      </div>
      </div>
      <div class="row filter-2 mt-4">
        <div class="col-md-12">
      <div class="heading mt-2">Payment Status</div>
      <div class="line_heading" style="width: 11rem !important;"></div>
      <div class="row">
        <div class="col-md-6 mt-4 mb-4">
        <ng-container *ngIf="doughnutChartData7">
        <canvas baseChart width="2" height="1"
          [data]="doughnutChartData7"
          [labels]="pieChartLabels"
          [options]="doughChartOptions"
          [chartType]="doughnutChartType"
          id="firstChart"
          [colors]="colors"
          (chartHover)="chartHovered($event)"
          (chartClick)="chartClicked7($event)"></canvas>
          </ng-container>
          </div>
          <div class="col-md-6">
            <div class="note_obc p-3">
              <div class="font_note">Note(OB-OC)</div>
              <div class="font_boq">BOQ value < 5 Lakh - 20 Days</div>
              <div class="font_boq">5-20 Lakh - 30 Days</div>
              <div class="font_boq">>20 Lakh - 45 Days</div>
              </div>
              <div class="mt-4" style="margin-left: -3rem;"><span style="color: #8d0528;">{{percentage_delayed | number : '.1-2'}}%</span> of your Leads are delayed
                </div>
            </div>
          </div>
          </div>
        </div>
      </div>
  </div>

  <div class="row filter-2 mt-4">
    <div class="col-md-12">
    <div class="heading mt-2">Site Validation and Order Confirmation</div>
      <div class="line_heading" style="width: 22rem !important"></div>
      <div class="row mt-3">
    <div class="col-md-4 mb-4 mt-2">
      <h5 class="text-center">Site Validation</h5>
      <ng-container *ngIf="doughnutChartData4">
      <canvas baseChart
          [data]="doughnutChartData4"
          [labels]="pieChartLabels"
          [chartType]="doughnutChartType"
          [colors]="colors"
          (chartHover)="chartHovered($event)"
          (chartClick)="chartClicked4($event)"></canvas>
          </ng-container>
      </div>
<div class="col-md-4">
  <h5 class="text-center">QC Submit</h5>
      <ng-container *ngIf="doughnutChartData5">
      <canvas baseChart
          [data]="doughnutChartData5"
          [labels]="pieChartLabels"
          [chartType]="doughnutChartType"
          [colors]="colors"
          (chartHover)="chartHovered($event)"
          (chartClick)="chartClicked5($event)"></canvas>
          </ng-container>
      </div>
      <div class="col-md-4">
        <h5 class="text-center">QC Approval</h5>
        <ng-container *ngIf="doughnutChartData6">
      <canvas baseChart
          [data]="doughnutChartData6"
          [labels]="pieChartLabels"
          [chartType]="doughnutChartType"
          [colors]="colors"
          (chartHover)="chartHovered($event)"
          (chartClick)="chartClicked6($event)"></canvas>
          </ng-container>
      </div>
      </div>
    </div>
    </div>

    <div class="row mt-4">
    <div class="col-md-12">
      <div class="row">
        <div class="col-md-8">
          <div class="filter-2">
            <!-- <div class="col-md-12"> -->
    <div class="heading ml-4 pt-3">Speed Of Order Booking to Order Confirmation</div>
      <div class="line_heading" style="width: 25rem !important;"></div>
      <div class="row">
    <div class="col-md-8">
      <ng-container *ngIf="needleValue">
      <rg-gauge-chart
    [canvasWidth]="canvasWidth"
    [needleValue]="needleValue"
    [centralLabel]="centralLabel"
    [options]="options"
    [name]="name"></rg-gauge-chart>
    <div class="row img_row_style">
      <div class="first_img"><img src="../../assets/img/Vector (1).png" /></div>
      <div class="second_img"><img src="../../assets/img/Vector.png" /></div>
      <div></div>
      </div>
    </ng-container>
      </div>
      <div class="col-md-4 mt-4">
        <div class="mb-2">Target&nbsp;&nbsp;  <span style="color: #8d0528;">30</span></div>
        <div class="mb-3">Actual&nbsp;&nbsp;<span style="color: #8d0528;">{{bottomLabel | number : '.1-2'}}</span></div>
        <div class="mb-3"><img src="../../assets/img/Vector (1).png" /><span class="ml-4">Fast</span></div>
        <div><img src="../../assets/img/Vector.png" /><span class="ml-4">Slow</span></div>
        </div>
      </div>
      </div>
      </div>
      <!-- <div class="col-md-4">
          <div class="filter-2">
    <div class="heading ml-4 pt-3">Incentives</div>
      <div class="line_heading" style="width: 10rem !important;"></div>
      <div class="row">
    <div class="col-md-12 mb-5">
      <div class="text-center mt-4">Number of Orders
        </div>
        <div class="text-center font-weight-bold">123</div>
        <div class="text-center mt-4">Total order value 
        </div>
        <div class="text-center font-weight-bold">₹ 1,22,425</div>
        <div class="text-center mt-4">Incentive earned 
        </div>
        <div class="text-center font-weight-bold">₹ 1,22,425</div>
      </div>
      </div>
      </div>
      </div> -->
      </div>
      </div>
    </div>
    </div>
    </div>
    </div>

<div class="modal fade" id="onTrackModal" role="dialog">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="text-center">{{header_name}}</h4>
        <button type="button" class="close addCursor" data-dismiss="modal">&times;</button>
      </div>
      <div class="modal-body">
        <table class="table">
            <tr>
              <th>Lead Id</th>
              <th>Lead Name</th>
              <th *ngIf="quotation_delayed">Quotation Delayed</th>
              <th *ngIf="boq_reference">BOQ Reference No</th>
            </tr>

            <tr *ngFor="let events of overall_info_table | paginate
          : {
              id:'pagination2',
              itemsPerPage: 10,
              currentPage: current_page2,
              totalItems: total_page2
            }; let i=index">
              <td>{{events.lead_id}}</td>
              <td ><a class="hover_effect" href="{{baseUrl + '/lead/' + events.lead_id +'/activity-logs?lead_status=leads_total_qualified'}}" target="blank">{{events.lead_name}}</a></td>
              <td *ngIf="quotation_delayed">{{events.quotations_delayed}}</td>
              <td *ngIf="boq_reference">{{events.boq_reference_number}}</td>
            </tr>
          </table>
          <div class="text-center mt-3">
          <pagination-controls id="pagination2" autoHide="true" (pageChange)="pageChanged($event)"></pagination-controls>
         </div>
      </div>
    </div>
  </div>
</div>

<div class="loading d-block justify-content-center" *ngIf="loader">
		<div class="spinner-border" style="color: #8d0528;" role="status">
			<span class="sr-only">Loading...</span>
		</div>
	</div>


// WEBPACK FOOTER //
// ./src/app/platform/customer/designer-dashboard/designer-dashboard.component.html